import { UserAvatar } from "@/components/user";

import { UserSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type UserSearchItemViewProps = {
  item: UserSearchItem;
};

export const UserSearchItemView = ({ item }: UserSearchItemViewProps) => {
  const fullName = [item.user.name, item.user.surname].filter(Boolean).join(" ").trim();
  // Prefer the human-facing Tournated tag as the subtitle; fall back to email
  // (the previous value) when a user has no tag assigned.
  const subtitle = item.user.tournatedTag || item.user.email || "";

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <UserAvatar className="h-[30px] w-[30px]" user={item.user} width={30} height={30} />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{fullName || subtitle}</SearchItemLabel>
          <SearchItemDescription>{subtitle}</SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="user" />
      </div>
    </div>
  );
};
